import { TTicketDetails } from '@daymade/api-contracts';
import CardList from 'components/CardList';
import Ticket from 'components/Ticket';
import { DEFAULT_MESSAGE } from 'utils/account/DefaultTicketMessage';

interface EntriesSectionProps {
  tickets: TTicketDetails[] | null;
  loading: boolean;
  numberOfTicketsToShow: number;
  showMessage?: boolean;
}

export const EntriesSection: React.FC<EntriesSectionProps> = ({
  showMessage = false,
  tickets,
  loading,
  numberOfTicketsToShow,
}) => {
  if (loading || !tickets || tickets.length === 0) {
    return showMessage ? (
      <p className="text-center">{DEFAULT_MESSAGE}</p>
    ) : null;
  }

  return tickets.slice(0, numberOfTicketsToShow).length === 1 ? (
    <Ticket
      ticket={tickets[0]}
      hidePurchaseDate
      hidePrice
      optionalRevealLink={undefined}
    />
  ) : (
    <CardList
      style={{ width: '100%' }}
      id="ticketsWithEntriesForScheduledDraws"
      noDots
      arrowStyle={2}
    >
      {tickets.slice(0, numberOfTicketsToShow).map((ticketWithEntries, idx) => (
        <Ticket
          key={`ticket${idx}`}
          ticket={ticketWithEntries}
          hidePurchaseDate
          hidePrice
          optionalRevealLink={undefined}
        />
      ))}
    </CardList>
  );
};
